import type { FaireProductEntity } from "../../entity_types/product";

export const p_b6x868b2km: FaireProductEntity = {
  token: "p_b6x868b2km",
  type: "product",
  name: "Frog Knit Toddler Backpack (Organic Cotton)",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ebe96d67c32f3f9355a36cb03a37a61437cf291794148584f6f02987f24be655.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f85f993c5b6568f4e3d89278ae9c3f8b76bf924902e4f00106d0e32d25308f80.png",
  ],
  priceDollars: 28,
  description:
    "Soft, playful, and full of personality, this frog knit toddler backpack has the lovable charm of a stuffed toy with the everyday function of a backpack.\n\nCrafted from soft, durable cotton knit, it features a cheerful green body with bright orange feet for a fun, nature-inspired look. The roomy zippered compartment is perfect for tiny treasures, snacks, small books, and everyday essentials. Measuring approximately 15 inches tall including the legs, it makes a playful statement while remaining designed for little ones to carry and enjoy.\n\nFinished with sturdy adjustable canvas straps for comfortable wear, this character backpack is perfect for preschool, daycare, travel, playdates, sleepovers, and everyday adventures. Its charming frog design encourages independence while bringing a happy little hop to every outing.\n\nMade in India with non-toxic cotton and child-friendly materials, and designed for comfort, charm, and everyday durability.\n\nA delightful gift for toddlers, birthdays, holidays, back-to-school, and little animal lovers.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:35.352Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
